(() => {
  'use strict';

  const fallbackRoutes = {
    '/pages/sauna-finder': '/pages/sauna-cost-calculator?view=sauna-finder',
    '/pages/compare-saunas': '/pages/sauna-cost-calculator?view=compare-saunas',
    '/pages/sauna-cost-calculator': '/pages/sauna-cost-calculator?view=sauna-cost-calculator',
    '/pages/sauna-heater-sizing': '/pages/sauna-cost-calculator?view=sauna-heater-sizing',
    '/pages/sauna-space-planner': '/pages/sauna-cost-calculator?view=sauna-space-planner',
    '/pages/sauna-project': '/pages/sauna-cost-calculator?view=sauna-project',
    '/pages/sauna-installation': '/pages/contact?view=sauna-installation',
    '/pages/trade': '/pages/contact?view=trade',
    '/pages/commercial-saunas': '/pages/contact?view=commercial-saunas',
    '/pages/sauna-passport': '/pages/contact?view=sauna-passport'
  };

  const cleanToolRoutesByView = {
    'sauna-finder': '/pages/sauna-finder',
    'compare-saunas': '/pages/compare-saunas',
    'sauna-cost-calculator': '/pages/sauna-cost-calculator',
    'sauna-heater-sizing': '/pages/sauna-heater-sizing',
    'sauna-space-planner': '/pages/sauna-space-planner',
    'sauna-project': '/pages/sauna-project'
  };

  const redirectLegacyToolView = () => {
    if (window.SweatDecksCleanToolRoutesReady !== true || window.location.pathname !== '/pages/sauna-cost-calculator') return false;
    const view = new URLSearchParams(window.location.search).get('view');
    const cleanRoute = cleanToolRoutesByView[view];
    if (!cleanRoute || (cleanRoute === window.location.pathname && !window.location.search)) return false;
    window.location.replace(`${cleanRoute}${window.location.hash}`);
    return true;
  };

  const rewriteUnavailableRoutes = (scope = document) => {
    const availability = window.SweatDecksRouteAvailability || {};
    scope.querySelectorAll('a[href]').forEach((anchor) => {
      const url = new URL(anchor.href, window.location.origin);
      if (url.origin !== window.location.origin || url.search || !fallbackRoutes[url.pathname]) return;
      const routeState = availability[url.pathname];
      const needsFallback = routeState === false || (routeState == null && window.SweatDecksPreviewRoutesEnabled === true);
      if (!needsFallback) return;
      anchor.href = fallbackRoutes[url.pathname];
      anchor.dataset.sdxRouteFallback = 'true';
    });
  };

  const getModelToken = (value = '') => {
    const trimmed = value.trim();
    if (!trimmed || /\s/.test(trimmed)) return null;
    const token = trimmed.replace(/^[^a-z0-9]+|[^a-z0-9-]+$/gi, '');
    return token.length >= 3 && /[a-z]/i.test(token) && /\d/.test(token) ? token : null;
  };

  const normalizeModelSearchLocation = () => {
    if (window.location.pathname !== '/search') return false;
    const params = new URLSearchParams(window.location.search);
    const modelToken = getModelToken(params.get('q') || '');
    if (!modelToken) return false;
    if (params.get('q') === modelToken && params.get('type') === 'product') return false;
    params.set('q', modelToken);
    params.set('type', 'product');
    params.delete('page');
    window.location.replace(`${window.location.pathname}?${params.toString()}${window.location.hash}`);
    return true;
  };

  const enhanceModelSearch = (scope = document) => {
    scope.querySelectorAll('form[data-sdx-search-assist], form[role="search"]').forEach((form) => {
      if (form.dataset.sdxModelSearchReady === 'true') return;
      form.dataset.sdxModelSearchReady = 'true';
      form.addEventListener('submit', () => {
        const input = form.querySelector('input[name="q"]');
        if (!input) return;
        const modelToken = getModelToken(input.value);
        if (!modelToken) return;
        input.value = modelToken;
        let typeInput = form.querySelector('input[name="type"]');
        if (!typeInput) {
          typeInput = document.createElement('input');
          typeInput.type = 'hidden';
          typeInput.name = 'type';
          form.append(typeInput);
        }
        typeInput.value = 'product';
      });
    });
  };

  class SdxCatalog extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.cards = [...this.querySelectorAll('[data-sdx-card]')];
      this.productMap = new Map(((window.SDX_SAUNA_DATA && window.SDX_SAUNA_DATA.products) || []).map((product) => [product.handle, product]));

      const facets = this.querySelector('.sdx-facets');
      if (facets && window.matchMedia('(max-width: 63.99rem)').matches && !facets.querySelector('[data-sdx-facets-toggle]')) {
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'sdx-facets__toggle';
        toggle.setAttribute('data-sdx-facets-toggle', '');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Filter products');
        toggle.textContent = 'Filter products';
        facets.classList.add('sdx-facets--collapsed');
        facets.prepend(toggle);
        toggle.addEventListener('click', () => {
          const expanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!expanded));
          toggle.setAttribute('aria-label', expanded ? 'Filter products' : 'Hide filters');
          toggle.textContent = expanded ? 'Filter products' : 'Hide filters';
          facets.classList.toggle('sdx-facets--collapsed', expanded);
        });
      }

      this.cards.forEach((card) => {
        const product = this.productMap.get(card.dataset.sdxHandle);
        if (!product) return;
        card.dataset.sdxCapacity = Number.isFinite(product.capacity) ? String(product.capacity) : '';
        card.dataset.sdxPlacement = Array.isArray(product.placement) ? product.placement.join('|') : '';
        const facts = card.querySelector('[data-sdx-card-facts]');
        if (facts) {
          const capacity = Number.isFinite(product.capacity) ? `${product.capacity} ${product.capacity === 1 ? 'person' : 'people'}` : '';
          const placement = Array.isArray(product.placement) && product.placement.length ? product.placement.join(' / ') : '';
          facts.textContent = [capacity, placement].filter(Boolean).join(' · ');
          facts.hidden = !facts.textContent;
        }
      });
    }
  }

  if (!customElements.get('sdx-catalog')) {
    customElements.define('sdx-catalog', SdxCatalog);
  }

  if (redirectLegacyToolView() || normalizeModelSearchLocation()) return;
  rewriteUnavailableRoutes();
  enhanceModelSearch();
  document.addEventListener('shopify:section:load', (event) => {
    rewriteUnavailableRoutes(event.target);
    enhanceModelSearch(event.target);
  });
})();
